import {Component, Input, OnInit} from '@angular/core';
import {ValidatorsService} from './validators.service';

@Component({
  selector: 'ngx-control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss'],
})
export class ControlMessagesComponent implements OnInit {
  @Input() control: any;
  @Input() nameInput: any;
  @Input() formSubmitted: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  get errorMessage() {
    for (const propertyName in this.control.errors) {
      if (
        ((this.control.invalid && (this.control.dirty ||
          this.control.touched)) || this.control.invalid &&
          this.formSubmitted) && this.control.errors.hasOwnProperty(propertyName)
      ) {
        return ValidatorsService.getValidatorErrorMessage(
          this.nameInput,
          propertyName,
          this.control.errors[propertyName],
        );
      }
    }
    return null;
  }
}
